export default {
    page_title: "Kevi | Campos del cliente",
    title: "Campos del cliente",
    add_group_button: "Agregar Grupo",
    add_field_button: "Agregar Campo",
    empty_group_message: "Arrastra campos a este grupo.",

    field_form: {
        title: "Creando campo",
        name_label: "Nombre",
        type_label: "Tipo",
        back_button: "Volver",
        save_button: "Guardar",
    },

    group_form_modal: {
        title_create: "Crear Nuevo Grupo",
        title_edit: "Editar Grupo",
        name_label: "Nombre del Grupo",
        name_placeholder: "Ej.: Datos Personales",
    },

    confirm_delete_group: {
        title: "¿Le gustaría eliminar el grupo",
        body_has_fields:
            "Este grupo contiene {0} campo(s). Mueva los campos a otro grupo antes de eliminarlo.",
        body_no_fields:
            'Esta acción es irreversible. Los campos dentro de él no serán eliminados, sino movidos al grupo "General".',
        attention: "Atención:",
        delete_button: "Eliminar",
    },

    confirm_delete_field: {
        title: "¿Le gustaría eliminar",
        body_no_relations:
            "Esta acción es irreversible, ¿está seguro de que desea continuar?",
        body_linked: "Este campo está vinculado a",
        linked_automations: "las siguientes automatizaciones:",
        linked_segments: "los siguientes segmentos:",
        warning_linked:
            "Se recomienda ajustar antes de eliminar; continuar ahora puede generar resultados inesperados.",
    },

    confirm_edit_field: {
        title: "¿Le gustaría editar el nombre a",
        body: "Asegúrese de que el nuevo nombre sea correcto antes de confirmar.",
    },

    tooltips: {
        edit_group: "Editar grupo",
        delete_group: "Eliminar grupo",
        edit_field: "Editar campo",
        delete_field: "Eliminar campo",
        move_field: "Mover Campo",
    },

    aria: {
        edit_group: "Editar grupo",
        delete_group: "Eliminar grupo",
        confirm_edit: "Confirmar edición",
        edit_field: "Editar campo",
        delete_field: "Eliminar campo",
        field_name: "Nombre",
    },

    notifications: {
        field_added: "Campo agregado",
        field_deleted: "Campo personalizado eliminado",
        field_edited: "Campo personalizado editado",
        group_created: "Grupo creado",
        group_updated: "Grupo actualizado",
        group_deleted: "Grupo eliminado",
        group_name_required: "El nombre del grupo es obligatorio.",
        group_has_fields_error:
            "No es posible eliminar un grupo que contiene campos.",
        group_create_error: "Error al crear el grupo.",
        group_update_error: "Error al actualizar el grupo.",
        group_delete_error: "Error al eliminar el grupo.",
        order_saved: "¡Orden guardado con éxito!",
        order_save_error: "Error al guardar el nuevo orden.",
    },
};
